import * as React from 'react';
import { BaseRouteProps } from '../../interfaces';

export class StripeFailure extends React.Component<BaseRouteProps<{ id: string }>> {
    public render() {
        return (
            <div className="Survey">
                <div className="content">
                    An error occurred while completing your purchase. Please contact us for assistance.
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/checkout/StripeFailure.tsx